export type U2000TabListOrientation = 'horizontal' | 'vertical';

/**
 * Résout l’id d’onglet cible après une touche de navigation (pattern WAI-ARIA Tabs).
 * Retourne null si la touche ne doit pas changer l’onglet actif.
 */
export function u2000ResolveTabIdAfterListKey(
  key: string,
  orientation: U2000TabListOrientation,
  tabIds: readonly string[],
  currentTabId: string,
): string | null {
  if (tabIds.length === 0) {
    return null;
  }

  const currentIndex = tabIds.indexOf(currentTabId);
  const index = currentIndex >= 0 ? currentIndex : 0;

  const prevKey = orientation === 'vertical' ? 'ArrowUp' : 'ArrowLeft';
  const nextKey = orientation === 'vertical' ? 'ArrowDown' : 'ArrowRight';

  if (key === 'Home') {
    return tabIds[0] ?? null;
  }
  if (key === 'End') {
    return tabIds[tabIds.length - 1] ?? null;
  }
  if (key === prevKey) {
    const nextIndex = index <= 0 ? tabIds.length - 1 : index - 1;
    return tabIds[nextIndex] ?? null;
  }
  if (key === nextKey) {
    const nextIndex = index >= tabIds.length - 1 ? 0 : index + 1;
    return tabIds[nextIndex] ?? null;
  }

  return null;
}
